import { ButtonProps } from "@animech/ui";
import * as Styled from "./custom-icon-button.style";

export const CustomIconButton: React.FC<ButtonProps> = ({
	children,
	...props
}) => {
	return (
		<Styled.CustomIconButton color="neutral" appearance="solid" {...props}>
			{children}
		</Styled.CustomIconButton>
	);
};
